import React from 'react'

const TrutedAdvisory = () => {
  return (
    <div>
       <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>

      <div className="strategic-points">
  <div className="points-card">
    <h2 className="points-title" style={{ fontSize: "38px" }}>
      TRUSTED ADVISORY AND MENTOR IN ESDM
    </h2>
    <div className="points-container">
      <div className="point-item">
        <span className="point-arrow">➤</span>
        <p className="point-text" style={{ fontSize: "19px" }}>
          Need of the hour for Indian startups is Mentoring for Funds, Scaling, Go to Market (GTM) Strategy
        </p>
      </div>

      <div className="point-item">
        <span className="point-arrow">➤</span>
        <p className="point-text highlighted" style={{ fontSize: "19px" }}>
          SEMANTIC aspires to be the First one-stop 'Go to Entity' for Electronics &amp; Semiconductor advisory in India
        </p>
      </div>

      <div className="point-item">
        <span className="point-arrow">➤</span>
        <p className="point-text highlighted" style={{ fontSize: "19px" }}>
          Help set up new startups in IP &amp; Product creation
        </p>
      </div>

      <div className="point-item">
        <span className="point-arrow">➤</span>
        <p className="point-text" style={{ fontSize: "19px" }}>
          Support Quantitative and Qualitative growth of existing companies
        </p>
      </div>

      <div className="point-item">
        <span className="point-arrow">➤</span>
        <p className="point-text highlighted" style={{ fontSize: "19px" }}>
          Help evolve a clear GTM strategy and shortest time to revenue
        </p>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default TrutedAdvisory
